import { render, staticRenderFns } from "./CmgOneTapReorderDetailsModal.vue?vue&type=template&id=246ecff0&scoped=true&lang=pug"
import script from "./cmg-one-tap-reorder-details-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-one-tap-reorder-details-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOneTapReorderDetailsModal.vue?vue&type=style&index=0&id=246ecff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ecff0",
  null
  
)

export default component.exports